import { Component } from '@angular/core';

@Component({
  selector: 'app-cards3-examples-21',
  templateUrl: './cards3-examples-21.component.html'
})
export class Cards3Examples21Component {}
